import { useState } from 'react';

import { toast } from '@/components/ui/toast';

type Props = {
  message: string;
};
export const useCopy = ({ message }: Props) => {
  const [copiedContent, setCopiedContent] = useState(false);

  const copyToClipboard = (content: string) => {
    try {
      navigator.clipboard.writeText(content);
      setCopiedContent(true);
      toast.success(message);
      setTimeout(() => setCopiedContent(false), 1500);
    } catch {
      toast.error('Copy failed');
    }
  };

  return {
    copiedContent,
    copyToClipboard,
  };
};
